import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  OnChanges,
  OnDestroy,
  Output,
  SimpleChanges,
} from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { utcDateTime } from '@epicuro-next/utilities';
import { isObjectEmpty } from '@epicuro-next/utilities';
import { NgbTimeStruct } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';

import { ngbDateTimeToUTC } from '../../utils';
import { DatePicker } from '../date-picker';

const TIME_PICKER_INITIAL_VALUE: NgbTimeStruct = {
  hour: 0,
  minute: 0,
  second: 0,
};

@Component({
  selector: 'atx-datetime-picker',
  templateUrl: './datetime-picker.component.html',
  styleUrls: ['./datetime-picker.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class DateTimePickerComponent
  extends DatePicker
  implements OnChanges, OnDestroy
{
  private destroy$ = new Subject<void>();
  public dateControl = new UntypedFormControl();
  public timeControl = new UntypedFormControl(TIME_PICKER_INITIAL_VALUE);

  @Output()
  public dateSelected = new EventEmitter<string>();

  @Output()
  public canceled = new EventEmitter();

  public ngOnChanges(changes: SimpleChanges) {
    const { startDate } = changes;
    if (startDate && startDate.currentValue) {
      const { day, month, year, hour, minute, second } = utcDateTime(
        startDate.currentValue,
      );
      this.dateControl.setValue({ day, month, year });
      this.timeControl.setValue({ hour, minute, second });
    }
  }

  public selectedDate() {
    const date = this.dateControl.value;
    const time = this.timeControl.value;
    const datetime = ngbDateTimeToUTC(date, time);
    this.dateSelected.emit(datetime);
  }

  public ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
    super.ngOnDestroy();
  }

  public isObjectEmpty(object: object): boolean {
    // because Object.keys(new Date()).length === 0;
    // we have to do some additional check
    return isObjectEmpty(object);
  }
}
